/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Status_FailedInputs */

const en_status_failed = /** @type {(inputs: Status_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`failed`)
};

const he_status_failed = /** @type {(inputs: Status_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`נכשל`)
};

/**
* | output |
* | --- |
* | "failed" |
*
* @param {Status_FailedInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const status_failed = /** @type {((inputs?: Status_FailedInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Status_FailedInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_status_failed(inputs)
	return he_status_failed(inputs)
});